import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function ({ store }) {
  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes: [],

    // Leave this as is and make changes in quasar.config.js instead!
    // quasar.config.js -> build -> vueRouterMode
    // quasar.config.js -> build -> publicPath
    history: process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory(process.env.VUE_ROUTER_BASE)
      : createWebHashHistory(process.env.VUE_ROUTER_BASE)
  })

  // Update push method to ignore NavigationDuplicated Errors
  const originalPush = Router.push
  Router.push = function push (location) {
    return new Promise((resolve, reject) => {
      originalPush.call(this, location, () => {
        resolve(this.currentRoute)
      }, (error) => {
        if (error.name === 'NavigationDuplicated') {
          resolve(this.currentRoute)
        } else {
          reject(error)
        }
      })
    })
  }

  if (process.env.APP_MODE !== 'admin') {
    Router.beforeEach((to, from, next) => {
      // Handling deprecated links that begin with hashes
      const redirectPath = to.hash.split('#')[1]
      if (to.fullPath === `/${to.hash}` && redirectPath) {
        next({
          path: redirectPath,
          hash: '',
          replace: true
        })
      } else {
        next()
      }
    })
  }

  // Expose control for pushing routes with plain JS
  window.$pushRoute = route => Router.push(route)

  return Router
}
